export default __webpack_public_path__ + "static-json/ne_50m_admin_0_boundary_lines_land-7bedc02af99ca8e50bfba6dea5629868.json";